import React from "react";

import ptBr from "../../../config/texts/pt-br";
import Styles from "../styles";
import { masks } from "../../../utils";
import { Grid } from "@material-ui/core";


function ModalView({ item }) {
  const texts = ptBr.login;

  const getConfigParam = (type: string): boolean => {
    const params = item?.place?.configurationParameters || item?.configurationParameters || [];
    const param = params.find((p: any) => p.type === type);
    return param?.value === "true";
  };

  const getStatus = (status: string) => {
    if (status === "DISPONIVEL") {
      return "Disponível";
    } else if (status === "OCUPADO") {
      return "Ocupado";
    } else if (status === "VAGO_SUJO") {
      return "Vago Sujo";
    } else if (status === "VAGO_LIMPO") {
      return "Vago Limpo";
    } else if (status === "INDISPONÍVEL") {
      return "Indisponível";
    } else {
      return "-";
    }
  };

  const getPropertyType = (status: string) => {
    if (status === "NORMAL") {
      return "Imóvel";
    } else if (status === "COWORKING") {
      return "Coworking";
    } else if (status === "PARTY_HALL") {
      return "Salão de Festas";
    } else {
      return "-";
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(250px, 26vw, 500px)",
          paddingInline: "25px",
          marginBottom: "20px",
        }}
      >
        <Grid alignItems="flex-end" container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Imóvel</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{item?.place?.name || item?.name}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Status</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{getStatus(item?.place?.status || item?.status)}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Data de Criação</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{item?.place?.createdAt || item?.createdAt}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Tipo de Imóvel</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{getPropertyType(item?.place?.type || item?.type)}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>{" "}
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Coleta da Facial</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{getConfigParam("GUEST_SHEET_FACIAL_ENABLED") ? "Sim" : "Não"}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>{" "}
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Status Fechadura</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{item?.place?.deviceStatus?.description || item?.deviceStatus?.description}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Coleta da Placa de Veículo</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{getConfigParam("GUEST_SHEET_VEHICLE_PLATE_ENABLED") ? "Sim" : "Não"}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Garagem</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>-</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.LabelViewImovel>Status de Manutenção</Styles.LabelViewImovel>
              <Styles.ValueViewImovel>{item?.place?.maintenance === true || item?.maintenance === true ? "Sim" : "Não"}</Styles.ValueViewImovel>
            </Styles.ConteudoContainer>
          </Grid>

        </Grid>
      </div>
    </>
  );
}

export default ModalView;
